module.exports = __webpack_public_path__ + "img/Blumenkind.f891cf3a.svg";